import { Box } from "@mui/material"
import { FunctionField, TextField } from "react-admin"
import { InvoiceReadModel } from "../../../GeneratedClients/FreeBillApi"

const InvoiceAdressComponent = () => {

  return (
    <Box >
      <FunctionField fontSize={12} render={(invoice: InvoiceReadModel) => `${invoice.invoiceIssuer?.company?.companyName} | ${invoice.invoiceIssuer?.company?.street} | ${invoice.invoiceIssuer?.company?.postCode} ${invoice.invoiceIssuer?.company?.city}`} />
      <TextField display={'block'} source="invoiceRecipient.company.companyName"/>
      <TextField display={'block'} source="invoiceRecipient.company.additionalAddress"/>
      <TextField display={'block'} source="invoiceRecipient.company.street"/>
      <FunctionField display={'block'} render={(invoice: InvoiceReadModel) => `${invoice.invoiceRecipient?.company?.postCode} ${invoice.invoiceRecipient?.company?.city}`} />
      <TextField display={'block'} source="invoiceRecipient.company.country"/>
    </Box>

  )
}

export default InvoiceAdressComponent